import React, { useEffect, useState } from 'react';
import { api } from '../api';
import Match from './Match';
import './TournamentPage.css';

function StandingsTable({ rows, onSelectTeam }) {
  return (
    <table className="standings">
      <thead>
        <tr>
          <th className="st-pos">#</th>
          <th className="st-team">Team</th>
          <th>Pld</th><th>W</th><th>D</th><th>L</th>
          <th>GF</th><th>GA</th><th>GD</th><th className="st-pts">Pts</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => {
          const advanced = /advance|knockout/i.test(r.qualification || '');
          return (
            <tr key={r.position} className={advanced ? 'st-advanced' : ''}>
              <td className="st-pos">{r.position}</td>
              <td className="st-team">
                <button className={`st-team-btn ${r.team_id ? 'clickable' : ''}`}
                  onClick={() => r.team_id && onSelectTeam({ id: r.team_id, name: r.team })}>
                  <img src={r.logo_url || '/team-placeholder.svg'} alt="" className="st-logo"
                    onError={(e) => { e.target.src = '/team-placeholder.svg'; }} />
                  <span>{r.team}</span>
                </button>
              </td>
              <td>{r.played}</td><td>{r.won}</td><td>{r.drawn}</td><td>{r.lost}</td>
              <td>{r.gf}</td><td>{r.ga}</td><td>{r.gd > 0 ? `+${r.gd}` : r.gd}</td>
              <td className="st-pts">{r.points}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

function TournamentPage({ onSelectTeam }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [tab, setTab] = useState('groups');

  useEffect(() => {
    let cancelled = false;
    api.tournament()
      .then(d => { if (!cancelled) setData(d); })
      .catch(e => { if (!cancelled) setError(e.message); });
    return () => { cancelled = true; };
  }, []);

  if (error) return <div className="tournament"><div className="tournament-error">Error: {error}</div></div>;
  if (!data) return <div className="tournament"><div className="tournament-loading">Loading…</div></div>;

  return (
    <div className="tournament">
      <div className="tournament-head">
        <h1>FIFA World Cup 2026</h1>
        <div className="tournament-tabs">
          <button className={tab === 'groups' ? 'active' : ''} onClick={() => setTab('groups')}>Groups</button>
          <button className={tab === 'knockout' ? 'active' : ''} onClick={() => setTab('knockout')}>Knockout</button>
        </div>
      </div>

      {tab === 'groups' && (
        <div className="group-cards">
          {data.groups.map((g) => (
            <section className="group-card" key={g.label}>
              <h2 className="group-title">Group {g.label}</h2>
              <StandingsTable rows={g.standings} onSelectTeam={onSelectTeam} />
              <div className="group-matches">
                {g.matches.map((m, i) => <Match key={i} match={m} onSelectTeam={onSelectTeam} />)}
              </div>
            </section>
          ))}
        </div>
      )}

      {tab === 'knockout' && (
        <div className="knockout">
          {data.knockout.map((round) => (
            <section className="knockout-round" key={round.round}>
              <h2 className="round-title">{round.round}</h2>
              <div className="round-matches">
                {round.matches.map((m, i) => <Match key={i} match={m} onSelectTeam={onSelectTeam} />)}
              </div>
            </section>
          ))}
        </div>
      )}
    </div>
  );
}

export default TournamentPage;
